export default __webpack_public_path__ + "static/poster-0bbff2893d2a0a8026d6365091a04699.png";